module.exports = {
  InteractiveItem: {
    PluginName: "İnteraktif Öğe",
    Empty: "İnteraktif öğe bulunamadı",
    Edit: "Düzenle",
    AiEdit: "AI ile düzenle",
    AiEditHint:
      "Ne değişsin yaz — görünüm, içerik ya da davranış. Mevcut öğenin üzerine uygulanır.",
    AiEditPlaceholder:
      "Örn: kartları daha renkli yap · bir soru daha ekle · sürükleme yerine tıklamayla olsun",
    AiEditRunning: "Değişiklik uygulanıyor",
    AiEditApply: "Uygula",
    AiEditUnavailable: "Bu öğe AI ile düzenlenemiyor (kaynağı yok). Yeni bir öğe üretebilirsin.",
    EditHint: "İçeriği düzenle — yeniden üretim gerekmez",
    TryOn: "Dene",
    TryOff: "✓ Deneme açık",
    TryOnHint: "Aktiviteyi denemek için aç",
    TryOffHint: "Kutuyu taşımak için kapat",

    ModalTitle: "İnteraktif Öğe Ekle",
    GoalQuestion: "Ne yapmak istiyorsun?",
    Suggestions: "Sana üç öneri",
    ShowAll: "Tüm tipleri göster",
    ModeWrite: "Prompt Yaz",
    ModeNarration: "Anlatımdan",
    NoNarration: "Bu sahnenin anlatımı yok",
    NeedInput: "Bu sahnenin anlatımı yok — yukarıya bir konu yaz.",
    PromptPlaceholder: "Ne üzerine olsun? Örn: yangın tüpü kullanım adımları",
    PromptOverride: "Anlatım yerine başka bir konu (opsiyonel)",
    AccentColor: "Ana renk",
    AccentColorNote: "Yüzeyler, tonlar ve degradeler bundan türetilir",
    CustomColor: "Özel renk",
    AllTypes: "Tüm tipler",
    Thinking: "Anlatım okunuyor…",
    Generating: "Aktivite yazılıyor",
    GeneratingMeta: "Birkaç dakika sürebilir — modalı kapatabilirsin, iş arka planda devam eder.",
    Again: "Başka bir şey dene",
    Add: "Sahneye ekle",
    Scored: "puanlı",
    Unscored: "puansız",
    SeeExample: "Örneğini gör",
    ExampleTag: "örnek",
    ExampleHint:
      "Gerçekten üretilmiş bir çıktı — deneyebilirsin. İçerik yer tutucudur, senin anlatımınla üretilecek olan budur.",

    EditorHint: "İçeriği buradan değiştir — yeniden üretim yok, kredi harcanmaz.",
    Apply: "Uygula",
    AddRow: "Ekle",
    MinRows: "Daha az olamaz",
    ModelAuto: "Otomatik (Sonnet 5.5)",
    ModelSonnet: "Sonnet 5.5",
    ModelOpus: "Opus 5.5",
  },
};
